/** Network-folder (WebDAV) document library.
 *
 * The browser can't reach the share directly (no CORS), so every call goes
 * through the backend, which proxies browsing and does the file transfer.
 * Gated server-side by the `networkFolder` feature flag — endpoints 503 when
 * the stand has it disabled.
 */

import { apiFetch } from "@/shared/api";

export interface WebdavEntry {
  name: string;
  path: string;
  isDir: boolean;
  size: number;
}

export interface WebdavItem {
  path: string;
  isDir: boolean;
}

export async function listWebdav(path: string): Promise<WebdavEntry[]> {
  const r = await apiFetch(`/api/webdav/list?path=${encodeURIComponent(path)}`, undefined, {
    crossSpace: true,
  });
  if (!r.ok) throw new Error(`webdav list ${r.status}`);
  const data = (await r.json()) as { entries?: WebdavEntry[] };
  return data.entries ?? [];
}

export interface ImportResult {
  imported: number;
  skipped: string[];
}

/** Copy selected WebDAV files/folders into the session workspace. `base`,
 *  when set, is stripped from each path so a folder's contents can land at
 *  the workspace root instead of nested under ancestor dirs. */
export async function importWebdav(
  sessionId: string,
  items: WebdavItem[],
  base = "",
): Promise<ImportResult> {
  const r = await apiFetch(`/api/sessions/${encodeURIComponent(sessionId)}/files/import-webdav`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items, base }),
  });
  if (!r.ok) throw new Error(`webdav import ${r.status}`);
  return r.json();
}
